import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { shallowEqual, useSelector } from 'react-redux'

import { observationClient, ObservationStats } from '../clients/ObservationClient'
import { GateFeedFilter } from '../clients/type'
import { selectUserToken } from '../store/user'
import { ApiError } from '../util/errors/ApiError'

export const useYardReport = (params?: {
  filters?: GateFeedFilter[]
}): {
  data: ObservationStats[]
  isLoading: boolean
  error: Error | undefined
} => {
  const token = useSelector(selectUserToken, shallowEqual)

  const [keys, siteId] = useMemo(() => {
    const siteFilter = params?.filters?.find((filter) => filter.type === 'site')
    const locationKey: string[] = []

    if (siteFilter?.type === 'site') locationKey.push(siteFilter.value.value)

    return [['getObservationStats', token, ...locationKey], ...locationKey]
  }, [token, params?.filters])

  const {
    data = [],
    status,
    error,
  } = useQuery(
    keys,
    () => {
      if (!token) throw new ApiError({ type: 'Unauthorized' })
      return observationClient.getObservationReport({ token, siteId })
    },
    {
      enabled: !!token,
      refetchInterval: 120000,
    }
  )

  return {
    data,
    isLoading: status === 'loading',
    error: error instanceof Error ? error : undefined,
  }
}
